module.exports = __webpack_public_path__ + "img/e2x.779d083a.png";